export class DemanderSignature 
{
    refDossierPortail:String;
    idFichierASigner:String;
    commentaire:String;
}
  